import Vue from "vue";

import vueSmoothScroll from "vue2-smooth-scroll";

Vue.use(vueSmoothScroll);
